import { useContext } from 'react'
import { Outlet, Navigate } from 'react-router-dom'

import { AuthContext } from '@/contexts/AuthContext'

export default function ProtectedRoute() {
  const { auth } = useContext(AuthContext)

  return (auth.isLoaded && !auth.isEmpty) ? <Outlet /> : (<Navigate to="/?modal=auth&tab=login" />)
}